import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from "react-router-dom"
import { ConfigProvider, message } from 'antd'
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'

// import * as serviceWorker from './serviceWorker'
import reportWebVitals from './reportWebVitals'

import store from "./store/index"
import App from '@/App'

import './static/css/index.css'
import './static/css/App.css'
import { BASE_URL } from './static/constant'
message.config({maxCount: 1})
const customizeRenderEmpty = () => (
	<div
		style={{
			textAlign: 'center',
		}}>
		<img src={require('../src/static/img/ic-emtry.png')} style={{ width: 102, height: 72, marginTop: '50px', marginBottom: '17px' }} />
		<p style={{ fontSize: '20px' }}>No Data </p>
	</div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
const client = new ApolloClient({
	cache: new InMemoryCache(),
	uri: BASE_URL,
});
root.render(
	<ConfigProvider store={store} renderEmpty={customizeRenderEmpty}>
		<HashRouter>
			<ApolloProvider client={client}>
				<App />
			</ApolloProvider>
		</HashRouter>
	</ConfigProvider>,
	//    document.getElementById('root')
);


// serviceWorker.unregister();
reportWebVitals();
